import {
    RESET_PROCESS_ERROR,
    GET_JIGYOSHA_LIST,
    FAIL_GET_JIGYOSHA_LIST,
    SUCCESS_GET_JIGYOSHA_LIST,
    GET_ASN_CORPORATE_LIST,
    FAIL_GET_ASN_CORPORATE_LIST,
    SUCCESS_GET_ASN_CORPORATE_LIST,
    SET_ASN_CORPORATE_LIST,
    FAIL_SET_ASN_CORPORATE_LIST,
    SUCCESS_SET_ASN_CORPORATE_LIST,
    FETCH_CSV_MASTER_ASN_CORPORATE,
    FAIL_FETCH_CSV_MASTER_ASN_CORPORATE,
    SET_CSV_MASTER_ASN_CORPORATE,
    RESET_MASTER_ASN_CORPORATE,
} from '../../actions';
import {downloadCsvData} from '../../common/utils/download-csv';
import moment from 'moment';


const initialState = {
    data:[],
    isFetching: false,
    error: undefined,
    isProcessError : false,
};
export default function masterAsnCorporateSettings(state = initialState, action) {
    let ret = Object.assign({}, state, {});
    switch (action.type) {
        case GET_ASN_CORPORATE_LIST:
            ret.isFetching = true;
            return ret;
        case FAIL_GET_ASN_CORPORATE_LIST:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SUCCESS_GET_ASN_CORPORATE_LIST:
            ret.data = action.payload.data;
            ret.isFetching = false;
            return ret;
        case GET_JIGYOSHA_LIST:
            ret.isFetching = true;
            return ret;
        case FAIL_GET_JIGYOSHA_LIST:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SUCCESS_GET_JIGYOSHA_LIST:
            ret.jigyoshaData = action.payload.data;
            ret.isFetching = false;
            return ret;
        case SET_ASN_CORPORATE_LIST:
            ret.isFetching = true;
            return ret;
        case FAIL_SET_ASN_CORPORATE_LIST:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SUCCESS_SET_ASN_CORPORATE_LIST:
            ret.data = action.payload.data;
            ret.isFetching = false;
            return ret;
        case FETCH_CSV_MASTER_ASN_CORPORATE:
            ret.isFetching = true;
            return ret;
        case FAIL_FETCH_CSV_MASTER_ASN_CORPORATE:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SET_CSV_MASTER_ASN_CORPORATE:
            const csvData = action.payload.data;
            const columns = action.payload.columns;
            const now = moment().format('YYYYMMDDhhmmss');
            downloadCsvData("ASN連携企業管理"+now, columns,csvData);
            ret.isFetching = false;
            return ret;
        case RESET_MASTER_ASN_CORPORATE:
            ret.data=[];
            ret.jigyoshaData=[];
            ret.JigyoushaCD=null;
            return ret;
        case RESET_PROCESS_ERROR:
            ret.isProcessError = false;
            return ret;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/master/asn-corporate-management.js